export default {
    tagPicker_allTagsAreSelected: "Todos los tags"
};